import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { InvoiceService } from '../core/invoice.service';
import { InvoiceStatusRequest } from '../core/invoice.model';
import { initialStatus, loadingStatus } from '../../../../core/models/request-status.model';
import { ExcelDownloadService } from '../../../../core/services/excelDownload.service';

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrl: './invoice-details.component.scss',
  standalone: false,
})
export class InvoiceDetailsComponent implements OnInit, OnDestroy {
  invoiceRequest$ = new BehaviorSubject<InvoiceStatusRequest>({
    ...initialStatus,
  });
  invoiceNumber: any;
  subscription = new Subscription();
  constructor(
    private router: Router,
    private invoicesService: InvoiceService,
    private excelDownloadService: ExcelDownloadService,
  ) {}

  ngOnInit(): void {
    this.invoiceNumber = this.router.url.split('/').pop();
    this.getInvoice();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getInvoice(): void {
    this.invoiceRequest$.next({ ...loadingStatus });
    this.subscription.add(
      this.invoicesService
        .getInvoice({ uid: decodeURIComponent(this.invoiceNumber) || '' })
        .subscribe((response: InvoiceStatusRequest) => {
          this.invoiceRequest$.next(response);
        }),
    );
  }

  exportInvoice(fileType?: 'pdf' | 'xlsx'): void {
    this.subscription.add(
      this.invoicesService.exportInvoice({ uid: decodeURIComponent(this.invoiceNumber) || '', fileType }).subscribe(response => {
        this.excelDownloadService.downloadBase64File(response);
      }),
    );
  }
}
